import { lazy } from '@cobliteam/lazy-with-retries';

import { Location } from '@cobliteam/common-types';

const MediaLandingPage = lazy(
  () => import('@cobliteam/media/src/pages/MediaLandingPage')
);
const MultiCamLandingPage = lazy(
  () => import('@cobliteam/media/src/pages/MultiCamLandingPage')
);
const MediaEventPage = lazy(
  () => import('@cobliteam/media/src/pages/MediaEventPage')
);
const MediaRequestPage = lazy(
  () => import('@cobliteam/media/src/pages/MediaRequestPage')
);
const TripImageHistoryPage = lazy(
  () => import('@cobliteam/media/src/pages/TripImageHistoryPage')
);

const routes = [
  {
    path: Location.CAMERA_EVENT,
    component: MediaEventPage,
    accessDeniedDescription: 'ver vídeos da câmera',
  },
  {
    path: Location.CAMERA_REQUEST,
    component: MediaRequestPage,
    accessDeniedDescription: 'ver vídeos da câmera',
  },
  {
    path: Location.CAMERA,
    component: MediaLandingPage,
  },
  {
    path: Location.MULTICAM_LANDING_PAGE,
    featureFlag: 'showMulticamLandingPage',
    accessDeniedDescription: 'ver vídeos da câmera',
    component: MultiCamLandingPage,
  },
  {
    path: Location.CAMERA_TRIP_IMAGE_HISTORY,
    component: TripImageHistoryPage,
    accessDeniedDescription: 'ver vídeos da câmera',
  },
];

export default routes;
